<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>
              {{ $t("general.tags") }}
            </li>
            <li>{{ this.$t('general.tag_list') }}</li>
          </ul>
        </nav>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span> {{ $t("hashtag.management") }} </span>
          </h2>
        </div>
        <div class="section-header-right">
          <router-link :to="{ name: 'company.hashtags.add' }">
            <button class="btn btn-default" type="button" aria-expanded="false"
              :disabled="!$hasPermission('create_hashtag')"
              :style="{ cursor: !$hasPermission('create_hashtag') ? 'not-allowed' : 'pointer' }">
              <i class="uil-plus"></i> {{ $t("hashtag.add") }}
            </button>
          </router-link>
        </div>
      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between">
            <!-- <h4 class="d-inline-block mb-0"></h4> -->
            <!-- <div>
              <a href="#" class="btn btn-icon btn-hover btn-circle" aria-expanded="false">
                <i class="uil-search"></i>
              </a>
              <div class="uk-drop" uk-drop="mode: hover; pos: right-center; offset: 0" style="left: 91px; top: 159.297px;">
                <form class="uk-search uk-search-navbar uk-width-1-1">
                  <input class="uk-search-input shadow-0 uk-form-small" type="search" :placeholder="$t('general.search')" autofocus="" v-model="filter.search">
                </form>
              </div>
            </div> -->
            <div class="uk-search uk-search-navbar">
              <i class="uil-search position-absolute"></i>
              <input class="uk-search-input shadow-0 uk-form-small" type="search" v-model="filter.search"
                :placeholder="$t('general.search')" />
            </div>
            <div class="d-flex">
              <!-- Shorting -->
              <a href="#" class="btn btn-icon btn-hover  btn-circle" :uk-tooltip="$t('filters.sort_list')" title=""
                aria-expanded="false">
                <i class="uil-list-ui-alt"></i>
              </a>
              <div uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up" class="uk-dropdown">
                <ul class="uk-nav uk-dropdown-nav">
                  <li @click="sortOrder('name', 'asc')">
                    <a href="javascript:void(0)">{{ $t("sorting.a_z") }}</a>
                  </li>
                  <li @click="sortOrder('name', 'desc')">
                    <a href="javascript:void(0)">{{ $t("sorting.z_a") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'asc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_asc") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'desc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_desc") }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Table -->
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t("hashtag.name") }}</th>
                <th scope="col">{{ $t("general.added_at") }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="list">
              <!--user item-->
              <tr v-for="hashtag in formattedItem">
                <th scope="row">
                  <div class="media align-items-center">
                    <div class="">
                      <router-link :to="{
                        name: 'company.hashtags.edit',
                        params: { id: hashtag.id },
                      }" class="name h6 mb-0 text-sm">
                        {{ hashtag.name }}
                      </router-link>
                    </div>
                  </div>
                </th>
                <td>{{ hashtag.created_at }}</td>
                <td class="text-right">
                  <div class="actions ml-3">
                    <router-link :to="{
                      name: 'company.hashtags.edit',
                      params: { id: hashtag.id },
                    }" class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('faq_categories.edit')">
                      <i class="uil-edit "></i>
                    </router-link>
                    <a href="javascript:void(0)" class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('general.delete')"
                      title="" @click="removeHashtag(hashtag.id)" aria-expanded="false">
                      <i class="uil-minus-circle text-danger"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination v-if="pagination && pagination.hasOwnProperty('links')" :pagination="pagination"
          @changePage="setPage($event)"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import store from "@/core/services";
import Pagination from "@/assets/components/Pagination";
import hashtag_module, {
  BASE_URL as HASHTAG_BASE_URL,
  MODULE_NAME as HASHTAG_MODULE_NAME,
  ERROR as HASHTAG_ERROR,
  ITEMS as HASHTAG_ITEMS,
  GET_ITEMS as HASHTAG_GET_ITEMS,
  DELETE_ITEM as HASHTAG_DELETE_ITEM,
} from "@/core/services/store/hashtag.module";
import moment from "moment";
import { confirmDialogDelete } from "@/utils/confirmDialog";
export default {
  name: "HastagList",
  components: { DataTable, Pagination },
  data() {
    return {
      status_id: null,
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      sort_by: "id",
      sort_desc: "desc",
      filter: {
        search: null,
        orderBy: "id",
        sort: "desc",
      },

    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(HASHTAG_MODULE_NAME, hashtag_module);
  },
  computed: {
    items: {
      get() {
        return store.getters[HASHTAG_MODULE_NAME + "/" + HASHTAG_ITEMS];
      },
      set(value) { },
    },
    error: {
      get() {
        return store.getters[HASHTAG_MODULE_NAME + "/" + HASHTAG_ERROR];
      },
      set(value) { },
    },
    formattedItem() {
      let results = [];
      if (this.items === null || !("data" in this.items)) return [];
      this.pagination = this.items.data;

      this.items.data.data.forEach((currentItem) => {
        results.push({
          id: currentItem.id,
          name: currentItem.name,
          status: currentItem.status_id
            ? this.$t("general.active")
            : this.$t("general.passive"),
          created_at: currentItem.created_at
            ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
            : "-",
        });
      });

      return results;
    },
  },
  methods: {
    getHashtagResult() {
      let self = this;
      this.$store.dispatch(HASHTAG_MODULE_NAME + "/" + HASHTAG_GET_ITEMS, {
        url: HASHTAG_BASE_URL,
        filters: {
          datatable: true,
          like: self.filter.search,
          page: self.page,
          per_page: self.per_page,
          sort: self.filter.sort,
          order_by: self.filter.orderBy,
          status_id: self.status_id,
        },
      });
    },
    async removeHashtag(id) {
      const isConfirmed = await confirmDialogDelete({ context: this });

      if (isConfirmed) {
        this.$store
          .dispatch(HASHTAG_MODULE_NAME + "/" + HASHTAG_DELETE_ITEM, {
            url: HASHTAG_BASE_URL + "/" + id,
          })
          .then(() => {
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_deleted");
              this.getHashtagResult();
            } else this.errorMessages.push(this.error);
          });
      }

    },
    sortOrder(orderBy, sort, is_user = true) {
      let self = this;
      self.page = 1;
      self.filter.orderBy = orderBy;
      self.filter.sort = sort;

      this.getHashtagResult();
    },
    setPage(page, is_user = true) {
      let self = this;
      self.page = page;
      this.getHashtagResult();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  mounted() {
    // if(!this.GiftVisible){
    //   this.$router.push({name:'company.dashboard'})
    // }
    this.getHashtagResult();
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.getHashtagResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}
</style>
